import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    CollapsiblePanel,
    CollapsiblePanelBody,
    CollapsiblePanelHeader,
    HorizontalFlex,
    PadContainer,
} from 'smartsuite-ui';
import CustomizableTable from '../../../../viewDashboards/widgets/customizableTable/CustomizableTable';

function getHeaderLabel(headerData) {
    return (
        <HorizontalFlex>
            <span className="station-tables__header-item">
                {headerData.flightNumber}
            </span>
            <PadContainer cssClassModifiers={['pad-small']} />
            {`${headerData.departureStation}-${headerData.arrivalStation}`}
            <PadContainer cssClassModifiers={['pad-small']} />
            {headerData.arrivalDateTimeLocal}
        </HorizontalFlex>
    );
}

export default function InboundStationTable(props) {
    const [isCollapsed, setIsCollapsed] = useState(props.defaultCollapsed);

    return (
        <CollapsiblePanel
            isCollapsed={isCollapsed}
            onCollapse={() => setIsCollapsed(!isCollapsed)}
        >
            <CollapsiblePanelHeader
                autoHideRollupText={false}
                headerLabel={getHeaderLabel(props.headerData)}
            >
                <HorizontalFlex
                    cssClassModifiers={['justify-flex-end', 'flex-wrap']}
                >
                    <HorizontalFlex>
                        {`${props.customLabels['key:actioned']}:`}
                        <PadContainer cssClassModifiers={['pad-small']} />
                        <div className="station-tables__header-item">
                            {props.headerData.actionedBags}/
                            {props.headerData.problemBags}
                        </div>
                        <PadContainer />
                    </HorizontalFlex>
                </HorizontalFlex>
            </CollapsiblePanelHeader>
            <CollapsiblePanelBody>
                <CustomizableTable
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...props}
                    data={props.tableData}
                    formatValue={props.formatter}
                    metricRequest={props.tableRequest}
                />
            </CollapsiblePanelBody>
        </CollapsiblePanel>
    );
}

InboundStationTable.propTypes = {
    defaultCollapsed: PropTypes.bool.isRequired,
    formatter: PropTypes.func.isRequired,
    headerData: PropTypes.instanceOf(Object).isRequired,
    headerRequest: PropTypes.instanceOf(Object).isRequired,
    configuration: PropTypes.instanceOf(Object).isRequired,
    openLinksInNewTab: PropTypes.bool.isRequired,
    tableData: PropTypes.instanceOf(Array).isRequired,
    tableRequest: PropTypes.instanceOf(Object).isRequired,
    customLabels: PropTypes.instanceOf(Object).isRequired,
};
